import {
  SHOW_SSO_ERROR,
  TOGGLE_UPDATING,
  UPDATE_AUTH0_CONNECTION_DATA,
  UPDATE_AUTH0_DOMAIN_LIST,
  UPDATE_AUTH0_SETUP_DATA,
} from 'constants/actions';

const DEFAULT_STATE = {
  firstFetchDone: false,
  updating: false,
  connectionData: {},
  setupData: {},
  showSsoError: false,
  domainList: [],
};

const auth0Reducer = (state = DEFAULT_STATE, action) => {
  let newState;

  switch (action.type) {
    case UPDATE_AUTH0_CONNECTION_DATA:
      newState = {
        ...state,
        connectionData: action.connectionData,
        firstFetchDone: true,
        updating: false,
      };
      break;
    case UPDATE_AUTH0_SETUP_DATA:
      newState = {
        ...state,
        setupData: action.setupData,
      };
      break;
    case UPDATE_AUTH0_DOMAIN_LIST:
      newState = {
        ...state,
        domainList: [...action.domainList],
      };
      break;
    case TOGGLE_UPDATING:
      newState = {
        ...state,
        updating: action.updating,
      };
      break;
    case SHOW_SSO_ERROR:
      newState = {
        ...state,
        showSsoError: action.showSsoError,
      };
      break;
    default:
      return state;
  }

  return newState;
};

export default auth0Reducer;
